import {HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {inject, Injectable} from "@angular/core";
import {LoadingService} from "../services/loading.service";
import {finalize, Observable} from "rxjs";

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
    const loadingService = inject(LoadingService);

    // Muestra el spinner antes de que la petición salga
    loadingService.show();

    return next(req).pipe(
        // finalize() se ejecuta siempre, tanto en éxito como en error.
        finalize(() => loadingService.hide())
    );
};
